import { NeoModel } from "@singularsystems/neo-core";
import BaseCheckQueryConfigCommand from "./BaseCheckQueryConfigCommand";

@NeoModel
export default class CreateServiceProviderHouseCheckQuery extends BaseCheckQueryConfigCommand {
}